<template>
    <div id="OpportunityPageDetailTopLayout " class="mb-4 sm:mb-0">
        <slot />

        <div class="flex flex-col">
            <!-- The title is drawn twice (above the image on mobile, beside it on desktop). Only the
                 desktop copy is semantic: it stays readable to crawlers and screen readers on mobile
                 too (sr-only), so a heading such as the page's h1 exists exactly once. -->
            <div class="block sm:hidden" aria-hidden="true">
                <slot name="title" :decorative="true" />
            </div>

            <div :class="{ 'items-center': minified, 'flex flex-col-reverse gap-12 sm:block sm:space-x-4': jobLayout }">
                <div
                    ref="image"
                    class="float-left mr-2 h-fit text-gray-900 dark:text-txt-headings"
                    :class="{
                        'w-full min-w-[90px] max-w-[90px] sm:mr-4 sm:max-w-[284px]':
                            !minified && !jobLayout && !orgLayout,
                        'hidden sm:block': leftHiddenOnMobile,
                        'max-w-[64px] sm:mr-4': jobLayout || orgLayout,
                        'sm:mb-2 sm:max-w-[284px]': orgLayout
                    }"
                >
                    <slot name="image" />
                </div>

                <div v-if="$slots.side" class="sm:float-right" :class="{ 'mb-4 sm:mb-0 sm:max-w-[40%]': jobLayout }">
                    <slot name="side" />
                </div>

                <div v-if="$slots.title" class="sr-only sm:not-sr-only">
                    <slot name="title" :decorative="false" />
                </div>

                <div>
                    <slot name="highlights" />
                </div>

                <div v-if="$slots.description" :class="{ 'mt-2 sm:mt-4': !minified }">
                    <slot name="description" />
                </div>

                <div v-if="$slots.interests" :class="{ 'mb-4 mt-2 sm:mb-0 sm:mt-4': !minified, 'mt-2': minified }">
                    <slot name="interests" />
                </div>
            </div>
        </div>

        <div v-if="$slots.bottom" :class="minified ? 'clear-both mt-1' : 'clear-both my-3'">
            <slot name="bottom" />
        </div>

        <CLineBreak v-if="!minified && !hideLineBreak" class="mb-8 sm:mb-0 sm:mt-8 md:mt-10" />
    </div>
</template>

<script setup lang="ts">
interface Props {
    variant?: 'job'
    leftHiddenOnMobile?: boolean
    minified?: boolean
    hideLineBreak?: boolean
    jobLayout?: boolean
    orgLayout?: boolean
}

defineProps<Props>()
</script>
